import { Text } from "@fmc-digital/ui";

/**
 * Loading Page
 * Shown while the app initializes
 */
export function LoadingPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto" />
        <Text variant="bodyLarge" className="mt-4">
          Loading...
        </Text>
      </div>
    </div>
  );
}
